// Topic.js
import React, { useState, useContext, useEffect } from 'react';
import TopBar from './TopBar';
import Introduction from './Introduction';
import ReferenceContainer from './ReferenceContainer';
import RelatedTopicContainer from './RelatedTopicContainer';
import TagsContainer from './TagsContainer';
import { TopicProvider } from '../../contexts/TopicContext';
import AuthContext from '../../contexts/AuthContext';
import AuthService from '../../services/AuthService';
import { useParams } from 'react-router-dom';
import './Topic.css';

export function Topic({ topic, onCloseModal, onExerciseClick, onTestClick }) {

    const { user } = useContext(AuthContext);

    const { id: routeTopicId } = useParams();
    // Prefer prop id if available; if not, fallback to route id.
    const topicId = topic ? topic : routeTopicId;
    const [topicData, setTopicData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setTopicData(null);
            try {
                // Currently, fetching topic data also increase view count. Might want to separate this in the future                
                const response = await fetch(`/api/topic/${topicId}`);
                const res = await response.json();
                setTopicData(res.data);
                
                if (user) { 
                    // Add the visited topic into user's history list (backend and locally)
                    const responseAddHistory = await fetch('/api/userdata/addUserTopicHistory', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ topicId: topicId, userId: user.userProfileId })
                    });

                    if (responseAddHistory.ok) {
                        const res = await responseAddHistory.json();
                        user.topicHistory = res.data.topicHistory;
                        AuthService.syncLocalUserSession(user);
                    }
                }

            } catch (error) {
                console.error('Failed to fetch data:', error);
            }
        };

        fetchData();
    }, [topicId]);

    return (
        <TopicProvider value={topicData}>
            <div id="content-container" className={onCloseModal ? "content-container-no-padding" : "" }>
                <TopBar topicId={topicId} onCloseModal={onCloseModal} onExerciseClick={onExerciseClick} onTestClick={onTestClick} />
                <Introduction />
                <hr />
                {/*<div className="row">*/}
                {/*    <div className="col-6">*/}
                {/*        <TagsContainer />*/}
                {/*    </div>*/}
                {/*    <div className="col-6 left-divier">*/}
                {/*        <RelatedTopicContainer />*/}
                {/*    </div>    */}
                {/*</div>*/}
                {/*<hr/>*/}
                <ReferenceContainer topicId={topicId}/>
                {/*<div class="row show-more-container">*/}
                {/*    <div class="col-12 text-center">*/}
                {/*        <button class="btn tkmr-secondary-btn" value="Show More">Show More</button>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </TopicProvider>
    );
};

